import { TrashIcon } from '@heroicons/react/20/solid';
import BasicModal from '../../../components/modals/BasicModal';
import { Mixpanel } from '../../../services/Mixpanel';

export const DELETE_TYPES = {
  COLLECTION: {
    type: 'collection',
    title: 'Delete Collection?',
    mixpanelTrackEvent: 'Collection Deleted',
    getDescription: (collection) => {
      return (
        <p>
          This will permanently delete <span className='font-bold'>{collection.title}</span>. The
          resources in this collection will not be deleted. This action cannot be undone.
        </p>
      );
    },
  },
  PACKET: {
    type: 'packet',
    title: 'Delete Resource?',
    mixpanelTrackEvent: 'Packet Deleted',
    getDescription: (packet) => {
      return (
        <p>
          This will permanently delete <span className='font-bold'>{packet.title}</span>. This
          action cannot be undone.
        </p>
      );
    },
  },
  // Bulk delete from the My Resources multi-select bar. `item` is a summary ({ count }), not a
  // resource — the modal only ever needs the count to describe what's about to go.
  BULK_RESOURCES: {
    type: 'bulk_resources',
    title: 'Delete Resources?',
    mixpanelTrackEvent: 'Bulk Resources Deleted',
    getDescription: ({ count }) => {
      return (
        <p>
          This will permanently delete{' '}
          <span className='font-bold'>
            {count} {count === 1 ? 'resource' : 'resources'}
          </span>
          . This action cannot be undone.
        </p>
      );
    },
  },
  PROJECT: {
    type: 'project',
    title: 'Delete Resource?',
    mixpanelTrackEvent: 'Project Deleted',
    getDescription: (project) => {
      return (
        <p>
          This will permanently delete <span className='font-bold'>{project.title}</span> and all
          its resources. This action cannot be undone.
        </p>
      );
    },
  },
};

export const DeleteConfirmationModal = ({ onClose, config }) => {
  const { type, item, onDelete } = config;

  const title = type.title;

  return (
    <BasicModal
      showModal={true}
      setShowModal={onClose}
      title={title}
      iconBackground='bg-red-100'
      icon={<TrashIcon className='w-5 h-5 text-red-600' />}>
      <div>
        <div className='text-sm text-gray-600'>{type.getDescription(item)}</div>

        <div className='flex flex-row gap-x-2 text-sm items-end justify-end font-bold'>
          <button
            className='bg-white hover:bg-gray-100 border border-gray-300 text-gray-500 px-4 py-2 rounded-md'
            onClick={onClose}>
            Cancel
          </button>
          <button
            className='bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-md mt-4'
            onClick={() => {
              Mixpanel.track(type.mixpanelTrackEvent, {
                [type.type]: item,
              });
              onDelete();
              onClose();
            }}>
            Delete
          </button>
        </div>
      </div>
    </BasicModal>
  );
};
